<template>
  <div class="file-content">
    <div class="pd-row15 file-main-con">
      <el-upload
        ref="upload"
        :accept="accept"
        :action="actionUrl"
        :headers="headers"
        :file-list="fileList"
        :data="upLoadParam"
        :name="uploadParam.fileName"
        :before-upload="beforeUploadFile"
        :on-exceed="exceedFiles"
        :on-success="uploadSuccess"
        :on-remove="handleRemove"
        :on-change="changeFile"
        :limit="limitNum"
        :auto-upload="false"
        class="upload-container mg-top15">
        <div slot="tip" class="upload-list">
          <div v-show="!fileList.length" class="file-desc">未选择任何文件</div>
          <el-button
            :loading="uploadFileLoading"
            type="primary"
            size="small"
            class="btn-upload"
            @click="submitUpload">
            上传文件
          </el-button>
        </div>
        <el-button slot="trigger" type="text" @click="selectFiles">
          <i class="el-icon-folder-opened blue-color f-fs16"></i>
          <span class="blue-color">选择文件</span>
        </el-button>
        <el-button
          v-if="isHasDownloadTemplate"
          :loading="isLoad"
          slot="tip"
          type="text"
          class="btn-download"
          @click="downloadFile">
          <i class="el-icon-sold-out blue-color f-fs16"></i>
          <span class="blue-color">下载模板</span>
        </el-button>
        <div v-if="uploadTipTxt" slot="tip" class="upload-tip red-color">{{ uploadTipTxt }}</div>
      </el-upload>
    </div>
  </div>
</template>

<script>
import {
  downloadFile,
  uploadFile
} from '@/api/common'
import {
  getToken
} from '@/utils/auth'
export default {
  props: {
    limitNum: { // 限制上传个数
      type: Number,
      default: 1
    },
    actionUrl: {
      type: String,
      default: 'http://172.17.36.62:8081/api/data/file'
    },
    accept: {
      type: String,
      default: ''
    },
    upLoadParam: {
      type: Object,
      default: () => {}
    },
    isHasDownloadTemplate: {
      type: Boolean,
      default: true
    },
    uploadTipTxt: {
      type: String,
      default: ''
    },
    downLoadObj: {
      type: Object,
      default: () => {}
    },
    upLoadUrl: {
      type: String,
      default: ''
    },
    fileSuffix: {
      type: Array,
      default: () => {
        return ['xls', 'xlsx']
      }
    }
  },
  data() {
    return {
      isLoad: false,
      uploadFileLoading: false,
      fileList: [],
      uploadParam: {},
      headers: {
        contentType: 'multipart/form-data', // 需要指定上传的方式
        Authorization: getToken()
      }
    }
  },
  methods: {
    selectFiles() {
      // 自动移除已有文件
      this.fileList = []
      this.$refs.upload.clearFiles()
    },
    changeFile(file, fileList) {
      this.fileList = fileList
      this.uploadParam = {
        file: file.raw,
        fileName: file.name,
        userId: this.$store.state.userInfo.userId, // 当前用户id
        userName: this.$store.state.userInfo.userName // 当前用户name
      }
    },
    handleRemove(file, fileList) {
      this.selectFiles()
    },
    // 文件超出个数时的钩子
    exceedFiles(files, fileList) {
      console.log('文件超出个数：', files)
      this.$message.warning(`只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`)
    },
    // 下载文件
    downloadFile() {
      this.isLoad = true
      downloadFile(
        this.downLoadObj.url,
        this.downLoadObj.param || {},
        this.downLoadObj.fileName || '模板.xlsx',
        res => {
          this.isLoad = false
          if (res && (res.status * 1 === 200 || res.statusText === 'OK')) {
            this.$message({
              type: 'success',
              message: '下载成功！'
            })
            this.$emit('downLoadFileSuccess')
          } else {
            this.$message({
              type: 'warning',
              message: '下载失败，请稍后操作！'
            })
          }
        })
    },
    // 点击上传文件
    submitUpload() {
      if (!this.fileList.length) {
        this.$message({
          type: 'warning',
          message: '请选择文件后再上传！'
        })
        return
      }
      const file = this.fileList[0]
      const formData = new FormData()
      formData.append('userName', this.$store.state.userInfo.userName)
      formData.append('userId', this.$store.state.userInfo.userId)
      formData.append('fileName', file.name)
      formData.append('file', file.raw)
      uploadFile(this.upLoadUrl, formData, res => {
        if (res.status * 1 === 200 && res.data.indexOf('成功') >= 0) {
          this.$message({
            type: 'success',
            message: '上传成功，可在列表页面查看！'
          })
          this.$emit('upLoadSuccess', file)
          setTimeout(() => {
            this.fileList = []
            this.$refs.upload.clearFiles()
          }, 1000)
        } else {
          this.$message({
            type: 'warning',
            message: res.data || '上传失败，请稍后操作！'
          })
        }
      })
      // this.$refs.upload.submit()
    },
    // 文件上传之前的钩子
    beforeUploadFile(file) {
      const FileExt = file.name.replace(/.+\./, '')
      if (this.fileSuffix.indexOf(FileExt.toLowerCase()) === -1) {
        this.$message({
          type: 'warning',
          message: '请上传后缀名为' + this.fileSuffix.join('，') + '的附件！'
        })
        return false
      }
    },
    // 文件上传成功的钩子
    uploadSuccess(response, file, fileList) {
      if (response.code !== 200) {
        return this.$message.error(response.msg)
      } else {
        // 上传成功之后在这里写逻辑，比如：重新调用查询列表接口
        this.$emit('upLoadSuccess', response)
      }
    }
  }
}
</script>

<style lang="less">
.file-content {
  & .el-button [class*=el-icon-]+span {
    margin-left: 1px;
  }
  & .el-upload-list {
    float: left !important;
    border: 1px solid #e9e9e9;
    border-radius: 3px;
    width: 315px;
    min-height: 37px;
  }
  & .el-upload.el-upload--text {
    position: absolute;
    bottom: -5px;
  }
  & .el-upload-list__item:first-child {
    margin-top: 0;
  }
  & .el-upload-list__item {
    line-height: 34px;
  }
  & .el-upload-list__item .el-icon-close {
    top: 10px;
  }
}
</style>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.file-content {
  background: #fff;
  & .file-main-con{
    padding: 5px 50px 15px;
  }
  & .file-desc {
    border: 1px solid #e9e9e9;
    color: #999;
    border-radius: 3px;
    line-height: 35px;
    width: 315px;
    display: inline-block;
    text-align: center;
  }
  & .btn-list img {
    vertical-align: bottom;
  }
  & .upload-container {
    position: relative;
    overflow: hidden;
    padding-bottom: 40px;
  }
  & .btn-download {
    position: absolute;
    bottom: -5px;
    left: 100px;
  }
  & .upload-tip{
    position: absolute;
    bottom: 0;
    left: 75px;
    padding: 12px 0;
    font-size: 12px;
  }
  & .upload-list {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 40px;
  }
  & .btn-upload {
    position: absolute;
    bottom: 2px;
    left: 335px;
  }
}
</style>
